import { Component, OnDestroy, OnInit } from '@angular/core';
import { PlatformCommandResponse } from '@shared/commands/command-base';
import { IPlatformToolComponent, IPlatformToolHandler } from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import { InvalidateSubject } from '@shared/helpers/invalidate.subject';
import { MagicLinkModel, TabModel } from '@shared/models/platform-tool-models';
import {FlowChartDataService} from "@features/data-survey/services/flow-chart-data.service";
import {EliteFormFlowChartDataService} from "@features/elite-form/services/elite-form-flow-chart-data.service";

@Component({
    standalone: false,
    selector: 'app-platform-tool-elite-form-design',
  templateUrl: './platform-tool-elite-form-design.component.html',
  styleUrls: ['./platform-tool-elite-form-design.component.scss']
})
export class PlatformToolEliteFormDesignComponent implements OnInit, OnDestroy, IPlatformToolComponent {

  constructor(private flowChartDataService: FlowChartDataService, private eliteFormFlowChartDataService: EliteFormFlowChartDataService) { }
  handler: IPlatformToolHandler;
  magicLinkModel: MagicLinkModel;
  selectedTab: TabModel;
  invalidateSubject: InvalidateSubject;
  eliteformId: string;
  isQnrSet: boolean;

  onLoad() {
  }
  onBeforeExecuteNextCommand(): boolean {
    return null;
  }
  onAfterExecuteNextCommand(nextCommandResponse: PlatformCommandResponse) {
  }
  onBeforeExecutePreviousCommand(): boolean {
    return null;
  }
  onAfterExecutePreviousCommand(previousCommandResponse: PlatformCommandResponse) {
  }
  ngOnDestroy(): void {
  }

  ngOnInit() {
    this.eliteFormFlowChartDataService.schemaId = this.magicLinkModel.fieldValues['SchemaId'];
    this.eliteFormFlowChartDataService.isClientSchema = this.magicLinkModel.fieldValues['IsClientSchema'];
    this.eliteFormFlowChartDataService.initFlowchartData();
    this.eliteFormFlowChartDataService.excludeHiddenQuestion(true);
    this.eliteFormFlowChartDataService.setApi(this.selectedTab.tabData.Api);
    this.eliteFormFlowChartDataService.setIsClientDrive(this.selectedTab.tabData['IsClientDrive']);
    this.eliteformId = this.selectedTab.tabData['EliteFormId'];
    this.eliteFormFlowChartDataService.setFlowchartId(this.selectedTab.tabData['FlowchartId']);
    this.eliteFormFlowChartDataService.setSourceType(this.selectedTab.tabData['SourceType']);
    this.flowChartDataService.setFieldValues(this.selectedTab.tabData);
    console.log('this.flowChartDataService', this.flowChartDataService);
    if (this.selectedTab.tabData['IsQnrSet']) {
      this.isQnrSet = this.selectedTab.tabData['IsQnrSet'];
    }
  }

}
